import QRCode from 'qrcode'
let size = '5cm 3cm'
let css = `
  .qrcode{
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .id, .name{
    text-align: center;
    margin: 0;
    padding: 0 5px;
  }
  .name{
    max-height: 2em;
    overflow: hidden;
    margin-bottom: 10px;
  }`

const html = (items) => {
  return new Promise((finalResolve) => {
    let promises = []
    items.forEach((item) => {
      promises.push(
        new Promise((resolve) => {
          QRCode.toDataURL(item.QRCode, {
            width: item.QRSize,
            errorCorrectionLevel: 'L'
          }).then((url) => {
            resolve(
              `<div class="container">
                <div class="qrcode">
                  <img src="${url}">
                </div>
                <div class="info">
                  <div class="name">${item?.buyerName || '-'}</div>
                  <div class="id">${item?.identify || '-'}</div>
                </div>
              </div>
              <div class="page-break"></div>`
            )
          })
        })
      )
    })

    Promise.all(promises).then((values) => {
      finalResolve(values.join(''))
    })
  })
}

export default { html, css, size }
